<template>
    <div>
        <div class="top_banner">
            <div class="top_banner_text">
                <p>产品下载</p>
                <p>Products Download</p>
            </div>
        </div>
        <div class="w_1200 w_1200_boot w_1200_boot_padding change_padding" style="height: 600px;padding-top: 100px">
            <div class="left_list">
                <div class="left_test" v-for="(item,index) in list" :key="index" @click="fun(index)"
                     :class="active == index ? 'addclass' : '' ">
                    <img :src="item.url">
                    <p>{{item.test}}</p>
                </div>
            </div>
            <div class="right_list">
                <div class="right_test" v-for="(item,index) in list_date" :key="index+'001'" @click="fun(index)">
                    <div v-if="index == active">
                        <img class="img img_1" :src="item.img" v-if="item.img">
                        <img class="img img_2" :class="item.img?'img_11':''" :src="item.img_1">
                        <p class="right_test_p">
                            {{item.test}}<br v-if="item.test01">
                            {{item.test01}}<br v-if="item.test01">
                            {{item.test02}}<br v-if="item.test01">
                            <span class="span">{{item.test1}}</span>
                            {{item.test2}}
                        </p>
                        <p class="download" v-if="item.url" @click="getBlob(item)">

                            <span>{{item.type}}</span>
                            <img src="@/assets/img/pc_slices/up_img2.png" alt="">


                        </p>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "productDownload",
        data() {
            return {
                list: [
                    {test: '桌面客户端', url: require('@/assets/img/pc_slices/pc.png'), type: '1'},
                    {test: 'Office签章', url: require('@/assets/img/pc_slices/word.png'), type: '2'},
                    {test: '手机安卓端', url: require('@/assets/img/pc_slices/app.png'), type: '3'},
                    {test: '微信小程序', url: require('@/assets/img/pc_slices/wx.png'), type: '4'},
                    {test: '钉钉小程序', url: require('@/assets/img/pc_slices/dd.png'), type: '5'},
                ],
                list_date: [
                    {
                        test: '电脑桌面客户端应用，点击下载，一键安装，享受极致的PDF操作与签署体验。 操作系统：win7*64、win8*64、',
                        test1: 'win10*64',
                        test2: '（推荐）',
                        url: require('@/assets/img/pc_slices/app_1.png'),
                        type: '下载桌面客户端',
                        versionSaveId: '',
                        img: '',
                        name: '',
                        img_1: require('@/assets/img/pc_slices/pc_tu.png'),

                    }, {
                        test: 'Office办公软件签章插件，针对大众签章合同平台企业用户开放。',
                        test01: '系统环境：win10*64（推荐）',
                        test02: '软件环境：微软office2010/2013/2016/2019（32位）',
                        test1: 'WPS专业版11.8.2.8088',
                        test2: '（推荐）',
                        versionSaveId: '',
                        type: '下载Office签章',
                        url: require('@/assets/img/pc_slices/app_1.png'),
                        img: '',
                        name: '',
                        img_1: require('@/assets/img/pc_slices/office.png'),

                    }, {
                        test: '安卓APP客户端，打开',
                        test1: '手机浏览器',
                        versionSaveId: '',
                        test2: '扫一扫上方二维码，即刻下载，享受移动签署的全新体验。',
                        type: '下载安卓apk',
                        name: '',
                        url: '../../../assets/product/DZoneSign_Android_V1.0.0.apk',
                        img: require('@/assets/img/pc_slices/app_1.png'),
                        img_1: require('@/assets/img/pc_slices/app_2.png'),
                    }, {
                        test: '微信小程序，打开微信扫一扫上方二维码进入，即刻下载，享受移动签署的全新体验。',
                        test1: '',
                        test2: '',
                        img: require('@/assets/img/pc_slices/wx_1.png'),
                        img_1: require('@/assets/img/pc_slices/wx_2.png'),

                    }, {
                        test: '钉钉小程序，打开钉钉扫一扫上方二维码进入，即刻下载，享受移动签署的全新体验。',
                        test1: '',
                        test2: '',
                        img: require('@/assets/img/pc_slices/dd_1.png'),
                        img_1: require('@/assets/img/pc_slices/dd_2.png'),

                    },
                ],
                active: 0
            }
        },
        mounted() {
            this.get_app()
            this.get_pc()
            this.get_office()
            this.get_wx()
            this.get_dd()
        },
        methods: {
            fun(index) {
                this.active = index
            },
            getBlob(item) {
                var a = document.createElement('a');
                var liet = item.url.split("/filePath1")
                this.mySeal_file = this.$SIF.get_file + liet[1];
                // var url = this.$SIF.get_file+ '/group1/M00/00/79/wKgRDV7nN_KAZ0yMARle0GZLI5s811.apk?originName=app_v1.0.2.apk';
                var url = this.mySeal_file;
                a.href = url;
                a.download = item.name;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a)
            },
            get_app() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.file + "/admin/file/query/getPackage",
                    data: {
                        entity: {},
                        pageBean: {orderBy: "", pageNum: 1, pageSize: 10}

                    },
                    succFun: res => {
                        if (res.data) {
                            this.list_date[2].url = res.data.list[0].versionUrl
                            this.list_date[2].name = res.data.list[0].versionFileName
                            this.list_date[2].img_1 = res.data.list[0].qrCode
                            this.list_date[2].versionSaveId = res.data.list[0].versionSaveId
                        }
                    }, failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_pc() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.file + "/admin/file/query/getUpdatePackage",
                    data: {
                        entity: {
                            systemType: 'pc'
                        },
                        pageBean: {orderBy: "", pageNum: 1, pageSize: 10}

                    },
                    succFun: res => {
                        if (res.data) {
                            this.list_date[0].url = res.data.list[0].versionUrl
                            this.list_date[0].name = res.data.list[0].versionFileName
                            this.list_date[0].versionSaveId = res.data.list[0].versionSaveId
                        }
                    }, failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_office() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.file + "/admin/file/query/getOfficePackage",
                    data: {
                        entity: {},
                        pageBean: {orderBy: "", pageNum: 1, pageSize: 10}

                    },
                    succFun: res => {
                        if (res.data) {
                            this.list_date[1].url = res.data.list[0].versionUrl
                            this.list_date[1].versionSaveId = res.data.list[0].versionSaveId
                            this.list_date[1].name = res.data.list[0].versionFileName
                        }
                    }, failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_dd() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.file + "/admin/file/query/dingTalk",
                    data: {
                        entity: {},
                        pageBean: {orderBy: "", pageNum: 1, pageSize: 10}

                    },
                    succFun: res => {
                        if (res.data) {
                            this.list_date[4].img_1 = res.data.list[0].versionUrl
                        }
                    }, failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            get_wx() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.file + "/admin/file/query/weChat",
                    data: {
                        entity: {},
                        pageBean: {orderBy: "", pageNum: 1, pageSize: 10}

                    },
                    succFun: res => {
                        if (res.data) {
                            this.list_date[3].img_1 = res.data.list[0].versionUrl
                        }
                    }, failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .top_banner {
        background-image: url(~@/assets/img/banner/productDownload.png);
        background-size: 100% 100%;

    }

    .left_list {
        width: 200px;
        padding: 10px 0;
        float: left;
        border-right: 1px solid #96E2C0;
        cursor: pointer;
    }

    .left_test {
        padding: 5px 0;
        height: 37px;
        line-height: 37px;
        color: rgba(35, 35, 35, 0.6);
        position: relative;
        right: -3px;
        margin: 20px 0;
        font-size: 14px;
    }

    .left_test img {
        width: 25px;
        height: 25px;
        float: left;
        -webkit-filter: grayscale(60%);
        -moz-filter: grayscale(60%);
        -ms-filter: grayscale(60%);
        -o-filter: grayscale(60%);
        filter: grayscale(60%);
        filter: gray;
    }

    .addclass img {
        -webkit-filter: grayscale(0%);
        -moz-filter: grayscale(0%);
        -ms-filter: grayscale(0%);
        -o-filter: grayscale(0%);
        filter: grayscale(0%);
        filter: gray;
    }

    .left_test p {
        width: 70%;
        float: right;
        line-height: 25px;
    }

    .right_test_p {
        font-size: 14px;
        line-height: 20px;
        text-align: left;
    }

    .addclass {
        border-right: 4px solid #19BC73;
        color: #232323;
    }

    .right_list {
        width: 490px;
        float: left;
        margin-left: 200px;
        color: rgba(35, 35, 35, 0.6);
        text-align: center;
    }

    .right_test .img {
        margin-bottom: 50px;
    }

    .img_11 {
        width: 133px;
    }

    .img_1 {
        margin-right: 100px;
    }

    .right_test .span {
        font-weight: 600;
        color: #414141;
    }

    .download {
        width: 191px;
        height: 42px;
        margin: 0 auto;
        box-sizing: border-box;
        display: block;
        background-color: #19BC73;
        border-radius: 26px;
        line-height: 40px;
        font-size: 14px;
        color: #fff;
        vertical-align: middle;
        margin-top: 12px;
        -webkit-animation: bounceInUp ease-in-out 1.5s 1;
        animation: bounceInUp ease-in-out 1.5s 1;
        position: relative;
        cursor: pointer;
    }

    .download a {
        color: #fff;
    }

    .download img {
        position: absolute;
        right: 6px;
        top: 6px;
    }

    @media screen and (max-width: 1024px) and (min-width: 320px) {
        .left_list {
            width: 38%;
            padding: 10px 0;
            float: left;
            border-right: 1px solid #96E2C0;
            cursor: pointer;
        }

        .right_list {
            width: 60%;
            float: right;
            margin: 0;
        }
        .right_list .img_2{
            width: 100%;
        }
        .w_1200{
            padding: 2rem 1.5rem 0 1.5rem !important;
        }
    }
</style>